import CheckoutReviewVendorOrderSection from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSection";
import { CheckoutOrder } from "@/fetch/getCheckoutResponse";

export default function StandardDeliveryVendor({
  vendors,
  isConfirmationPage = false,
}: {
  vendors: CheckoutOrder[];
  isConfirmationPage?: boolean;
}) {
  return (
    <>
      {vendors?.map((vendorOrder, index) => (
        <CheckoutReviewVendorOrderSection
          key={index}
          shoppingCartVendorOrder={vendorOrder}
          isConfirmationPage={isConfirmationPage}
        />
      ))}
    </>
  );
}
